import React from "react";
import { Text } from "react-native-paper";
import { View } from "react-native";

const AccordionItem = ({subSection}) => (subSection.description.map
    ? subSection.description.map((item, id) => 
    <View style={{alignItems: "flex-start"}} key={`accordion-item-${id}`}>
        <View style={{flexDirection: "row"}}>
            <Text style={{color: "#666"}}>{'\u2022'}</Text>
            <Text style={{flex: 1, paddingLeft: 5, color: "#666"}}>{item}</Text> 
        </View> 
    </View>)
    : <Text>{subSection.description}</Text>);

export default AccordionItem;
